import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation} from "react-router-dom"; // ✅ Import this
import axios from "axios";
import "../css/PobDetailsDoctorChemistStockistwise.css";
import * as XLSX from "xlsx";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";
const PobDetailsDoctorChemistStockistwise = () => {
    const navigate = useNavigate();
    const { employeeId } = useParams(); // ✅ Get employeeId from URL
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    
    // Get month/year from URL params or use current as fallback
    const month = queryParams.get('monthKey') || new Date().getMonth() + 1;
    const year = queryParams.get('year') || new Date().getFullYear();

    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/api/combined-retailers/pob-details-doctor-chemist-stockistwise`, {
                    params: {
                        employee_id: employeeId,
                        month: month,
                        year: year
                    },
                    headers: getAuthHeaders()
                });
                setData(res.data);
            } catch (err) {
                setError("Failed to fetch POB details.");
                console.error(err);
            }
        };

        if (employeeId) {
            fetchData();
        } else {
            setError("Invalid or missing employee ID.");
        }
    }, [employeeId, month, year]);

    const handlePrint = () => {
        window.print();
      };
      
      const handleExport = () => {
        const worksheet = XLSX.utils.json_to_sheet(
          data.map((row, index) => ({
            "S.No": index + 1,
            "Type": row.stockist,
            "Type": row.type,
            "Code": row.code,
            "Retailer": row.retailer,
            "Working Date": row.working_date,
            "State": row.state,
            "City": row.city,
            "Area": row.area,
            "Mobile": row.mobile,
            "Address": row.address,
            "POB": row.pob
          }))
        );
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "POB Details");
        XLSX.writeFile(workbook, "POB_Details_Doctor_Chemist.xlsx");
      };
      
    
  return (
   
      <div className="PobDetailsDoctorChemistStockistwise-data-container">
        <div className="">
          <h2 className="text-center">Selected Employee (Employee ID:- {employeeId})</h2>
        </div>
        {error && <p className="error-text">{error}</p>}

      <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">
              <tr>
                <th>S.No</th>
                <th>Stockist</th>
                <th>Type</th>
                <th>Code</th>
                <th>Retailer</th>
                <th>Working Date</th>
                <th>State</th>
                <th>City</th>
                <th>Area</th>
                <th>Mobile</th>
                <th>Address</th>
                <th>POB</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.stockist}</td>
                    <td>{item.type}</td>
                    <td>{item.code}</td>
                    <td>{item.retailer}</td>
                    <td>{item.working_date}</td>
                    <td>{item.state}</td>
                    <td>{item.city}</td>
                    <td>{item.area}</td>
                    <td>{item.mobile}</td>
                    <td>{item.address}</td>
                    <td>{item.pob ? item.pob.toFixed(2) : "0.00"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="no-data">No records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        
   <div className="mt-4 flex gap-4 justify-center">
              <CustomButton onClick={handlePrint} label="Print" variant="print">
                🖨
              </CustomButton>
              <CustomButton
                onClick={handleExport}
                label="Export"
                variant="export"
              >
                📥
              </CustomButton>
            </div>
        </div>
      </div>
  );
};

export default PobDetailsDoctorChemistStockistwise;
